import {Margin, MarginRectStrategy} from './types'

export const isMarginEqual = (prevMargin: Margin, nextMargin: Margin): boolean => {
  return (
    prevMargin[0] === nextMargin[0] &&
    prevMargin[1] === nextMargin[1] &&
    prevMargin[2] === nextMargin[2] &&
    prevMargin[3] === nextMargin[3]
  )
}

export const getNextMargin = (strategies: MarginRectStrategy[], offset: Margin): Margin => {
  return strategies.reduce(([prevTop, prevRight, prevBottom, prevLeft], strategy) => {
    const {top = 0, right = 0, bottom = 0, left = 0} = strategy()

    return [prevTop + top, prevRight + right, prevBottom + bottom, prevLeft + left]
  }, offset)
}
